import { observable } from '@microsoft/fast-element';
import { DI } from '@microsoft/fast-foundation';
import { Route } from '@microsoft/fast-router';

export interface IIndividualProjectPageService {
  openIndividualProjectPage(projectId: string, vppaId?: string): void;

  vppaId: string;
}

class IndividualProjectPageServiceImpl implements IIndividualProjectPageService {
  constructor() {}
  @observable vppaId: string;

  openIndividualProjectPage(projectId: string, vppaId?: string): void {
    this.vppaId = null;
    if (vppaId) {
      this.vppaId = vppaId;
    }

    Route.path.push(`project/${projectId}`);
  }
}

export const IIndividualProjectPageService = DI.createInterface<IIndividualProjectPageService>(
  (x) => x.singleton(IndividualProjectPageServiceImpl)
);
